import Vue from "vue";

export function useCountdown() {
  const state = Vue.observable({
    timer: "00:00",
    duration: 0,
  });
  const timer = {
    get value() {
      return state.timer;
    },
    set value(next) {
      state.timer = next;
    },
  };
  const duration = {
    get value() {
      return state.duration;
    },
    set value(next) {
      state.duration = next;
    },
  };
  let intervalId;

  const tick = () => {
    let minutes;
    let seconds;

    minutes = parseInt(JSON.stringify(duration.value / 60), 10);
    seconds = parseInt(JSON.stringify(duration.value % 60), 10);

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    timer.value = `${minutes}:${seconds}`;

    --duration.value;
    return duration;
  };

  const startTimer = (minutes) => {
    stopTimer();

    duration.value = minutes * 60;

    tick();
    intervalId = window.setInterval(() => {
      tick();

      if (duration.value < 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalId);
    timer.value = "00:00";
    duration.value = 0;
  };

  return {
    timer,
    duration,
    startTimer,
    stopTimer,
  };
}
